@if (IsModal && DisplayList) {
  <div>
    <app-modal id="account-select-modal" [contentStyleInput]="{'max-width':'500px'}">
      <span class="app-modal-header">
        Select an Account
      </span>
      <div class="app-modal-body companyPickerBody">
        @for (company of this.model.companies; track company) {
          <div class="companyName-wrap">
            <!-- this has to be an anchor tag so the page will refresh with the new company selected-->
            <span class="companyItem" (click)="model.selectCompany(company)">{{company.name}}</span>
          </div>
        }
      </div>
    </app-modal>
  </div>
}

@if (!IsModal && DisplayList) {
  <div>
    @for (company of this.model.companies; track company) {
      <div class="companyName-wrap">
        <!-- this has to be an anchor tag so the page will refresh with the new company selected-->
        <span class="companyItem" (click)="model.selectCompany(company)">{{company.name}}</span>
      </div>
    }
  </div>
}


